import React from 'react';
import styled from 'styled-components';
import theme from '^/theme';
import PlusSvg from '^/assets/icons/photo-request/plus.svg';
import Tippy from '@tippyjs/react';
import Text from '^/components/organisms/ViewpointCaptureFoldersList/text';
import { useL10n } from '^/hooks';

interface PhotoRequestHeaderProps {
  title: string;
  onAddClick?(): void;
  testId?: string;
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${theme.colors.black[100]};
  display: flex;
  align-items: center;
`;

const Beta = styled.span`
  font-size: 12px;
  color: ${theme.colors.lightBlue[500]};
  margin-left: 8px;
  font-weight: 400;
`;

const AddButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: ${theme.colors.white[100]};
  color: ${theme.colors.coolGray[800]};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.coolGray[50]};
  }
`;

export const PhotoRequestHeader: React.FC<PhotoRequestHeaderProps> = ({
  title,
  onAddClick,
  testId,
}) => {
  const [l10n] = useL10n();

  return (
    <HeaderContainer data-testid={testId}>
      <Title>
        {title}
        <Beta>(Beta)</Beta>
      </Title>
      <Tippy content={l10n(Text.newMission)} theme="angelsw" arrow={false}>
        <AddButton onClick={onAddClick} data-testid={`${testId}-add-button`}>
          <PlusSvg />
        </AddButton>
      </Tippy>
    </HeaderContainer>
  );
};

export default PhotoRequestHeader;
